/** Custom jewelry (/custom-jewelry) — storefront labels and promo copy. */
import {
  BESPOKE_JEWELRY_TYPE_DEFAULTS,
  BESPOKE_OCCASION_DEFAULTS,
} from './bespokeFormOptionDefaults';

export const CUSTOM_JEWELRY_DEFAULTS = {
  enabled: true,
  show_on_shop: true,
  show_in_nav: true,
  show_in_footer: true,
  show_on_gift_finder: true,
  shop_button_label: 'Custom jewelry design',
  nav_label: 'Custom jewelry',
  card_eyebrow: 'Made to order',
  card_title: 'Design jewelry for your celebration',
  card_lead: 'Share your outfit photo — we match colours for haldi, mehendi, sangeet, or wedding.',
  card_cta: 'Start your design',
  hero_eyebrow: 'Bespoke studio',
  hero_title: 'Custom jewelry design',
  hero_lead:
    'Haldi, mehendi, sangeet, or wedding — upload your dress colours and tell us what you need. We reply with ideas and a quote.',
  hero_image: '',
  seo_title: 'Custom jewelry design | Saloni Designs',
  seo_description:
    'Share your outfit photo and occasion — we design handcrafted jardosi and festive jewelry made to order.',
  gift_finder_promo_title: 'Need something bespoke?',
  gift_finder_promo_lead:
    'We design jewelry to match your outfit for haldi, mehendi, sangeet, and wedding — upload a dress photo and get a quote.',
  gift_finder_promo_cta: 'Request custom design',
  trust_items: [
    { icon: '🎨', title: 'Colour matched', text: 'We design around your outfit photo' },
    { icon: '💬', title: 'Personal consult', text: 'Ideas & quote by WhatsApp or email' },
    { icon: '✋', title: 'Handcrafted', text: 'Jardosi & festive work in our studio' },
  ],
  breadcrumb_shop_label: 'Shop',
  breadcrumb_current_label: '',
  how_it_works_title: 'How it works',
  how_it_works_steps: [
    { text: 'Tell us your occasion and upload an outfit photo' },
    { text: 'We share design ideas & a quote on WhatsApp / email' },
    { text: 'Handcrafted in our studio for your celebration' },
  ],
  pendants_note_title: 'Ready-made with photo lockets?',
  pendants_note_before_link: 'Browse',
  pendants_note_link_label: 'pendants',
  pendants_note_link_href: '/shop/pendants',
  pendants_note_after_link:
    'and customize on the product page — chain length, photo upload, and more.',
  success_title: 'Request received',
  success_ref_prefix: 'Reference',
  success_fine_print:
    'We will reply on WhatsApp or email with design ideas and a quote. No payment is needed now.',
  success_view_requests_button: 'View my custom requests',
  success_sign_in_button: 'Sign in to track requests',
  success_submit_another_button: 'Submit another request',
  submit_success_message: 'Thank you — we will reach out with design ideas and a quote.',
  form_section_details: 'Your details',
  form_section_event: 'Your event',
  form_section_photos: 'Photos & inspiration',
  signed_in_note:
    'Signed in as {name} — your details are filled in below. Edit anything that should be different for this request.',
  form_label_name: 'Your name',
  form_label_phone: 'Phone / WhatsApp',
  form_label_email: 'Email',
  form_label_occasion: 'Occasion *',
  form_label_jewelry_type: 'Jewelry type *',
  form_label_jewelry_type_hint: 'Select all that apply',
  form_label_event_date: 'Event date',
  form_label_event_date_optional: '(optional)',
  form_upload_dress_label: 'Outfit / dress photos',
  form_upload_dress_hint:
    'Upload your saree, lehenga, or outfit — add multiple angles or close-ups of the fabric colour.',
  form_upload_ref_label: 'Reference / inspiration',
  form_upload_ref_hint: 'Pinterest screenshots, previous jewelry, or looks you love (optional).',
  form_label_notes: 'Design notes',
  form_notes_placeholder: 'Colours, jardosi style, budget range, pieces needed…',
  submit_button: 'Request custom design',
  submit_busy_label: 'Sending request…',
  submit_fine_print: "No payment now — we'll reply with ideas and a quote first.",
  occasions: BESPOKE_OCCASION_DEFAULTS.map((item) => ({ ...item })),
  jewelry_types: BESPOKE_JEWELRY_TYPE_DEFAULTS.map((item) => ({ ...item })),
};
